import React from "react";
import UserList from "../../Components/UserList";

const CorporateSponsors = () => {
  return <UserList role="corporate_sponsor" roleLabel="Corporate Sponsors" />;
};

export default CorporateSponsors;
